export default {"src":"/_next/static/media/notion.2b3bd9f5.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};